module.exports = __webpack_public_path__ + "static/media/alpha_13.e988d38c.png";